import waRequest from './wa-request';

const baseApi = '/cem-data/v1';

function queryDatasetDocuments({pathParams, params, data}) {
  const {datasetUId} = pathParams;
  const url = `${baseApi}/datasets/${datasetUId}/query`;

  return waRequest.requestAuthenticated({url, method: 'POST', params, data});
}

function deleteDatasetDocument({pathParams}) {
  const {datasetUId, documentUId} = pathParams;
  const url = `${baseApi}/datasets/${datasetUId}/documents/${documentUId}`;

  return waRequest.requestAuthenticated({url, method: 'DELETE'});
}

function getDatasetDocument({pathParams, params}) {
  const {datasetUId, documentUId} = pathParams;
  const url = `${baseApi}/datasets/${datasetUId}/documents/${documentUId}`;

  return waRequest.requestAuthenticated({url, method: 'GET', params});
}

function exportDataset({pathParams, params}) {
  const {datasetUId} = pathParams;
  const url = `${baseApi}/datasets/${datasetUId}/export`;

  return waRequest.requestAuthenticated({url, method: 'GET', params, responseType: 'blob'});
}

function getStreamingMedia({pathParams}) {
  const {datasetUId, documentUId} = pathParams;
  const url = `${baseApi}/vms/${datasetUId}/${documentUId}/streaming-media`;

  return waRequest.requestAuthenticated({url, method: 'GET'});
}

export default {
  queryDatasetDocuments,
  getDatasetDocument,
  deleteDatasetDocument,
  exportDataset,
  getStreamingMedia,
};
